import React from "react";
import { motion } from "framer-motion";
import ContactForm from "../components/ContactForm";

const Contact = () => {
  return (
    <div className="content-page">
      {/* Hero Banner */}
      <div className="content-page-header">
        <div className="absolute inset-0 bg-hero-mesh" />
        <div className="container mx-auto px-6 relative z-10 text-center">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-4xl md:text-5xl font-extrabold mb-3"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            Get in Touch
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="text-white/60 text-sm max-w-md mx-auto"
          >
            Have questions or need assistance? We're here to help. Fill out the form below and we'll get back to you.
          </motion.p>
        </div>
      </div>

      {/* Content */}
      <div className="content-page-body pb-16">
        <div className="content-card">
          <ContactForm />
        </div>
      </div>
    </div>
  );
};

export default Contact;